import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hideModal } from '../../actions/ModalActions';
import '../../stylesheets/registry/_aboutZola.less';
import importImages from '../../util/webpack';

const modalImages = importImages(require.context('../../assets/images/press', false, /\.(jpg|jpeg|png|gif|svg)(\?.*)?$/));

/**
 * About Zola Modal
 * Modal about Zola that appears on the public registry
 */
const AboutZolaModal = (props) => {
  const { closeModal } = props;

  return (
    <div id="about-zola-modal">
      <div className="modal-header about-top">
        <div className="logo zola-registry-logo-black-100">Zola</div>
        <div className="row">
          <div className="col-sm-9 col-xs-12">
            <h1>What’s Zola?</h1>
            <p>
              Zola, the fastest growing wedding company in the country, is reinventing the wedding planning and registry experience to make the happiest moment in our couples&apos; lives even happier. From engagement to wedding and decorating a couple’s newlywed home, Zola is there, combining compassionate customer service with modern tools and technology. All in the service of love.
            </p>
            <p>
              Questions? We’re always happy to help. Reach out to us at <a href="mailto:support@zola.com">support@zola.com</a> or 408-657-ZOLA (9652).
            </p>
          </div>
        </div>
      </div>
      <div className="about-quotes">
        <h1>Guests<span className="text-lowercase script">  love </span>Zola</h1>
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <div className="quote">
              <p>
                &ldquo;Zola&apos;s so easy to use and we love knowing that we bought a gift our friends actually want. We didn&apos;t have to settle for something that felt impersonal.&rdquo;
              </p>
              <small className="text-uppercase">Nick and Christine P.</small>
            </div>
            <div className="quote">
              <p>
                &ldquo;I&apos;m actually using Zola for my own registry and have been raving about it to my friends. It is beyond convenient. I love Zola!&rdquo;
              </p>
              <small className="text-uppercase">Mary Kate B.</small>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6">
            <div className="quote">
              <p>
                &ldquo;I love how you can contribute to meaningful experiences and chip in with others on a group gift that otherwise might be too expensive for just one person.&rdquo;
              </p>
              <small className="text-uppercase">Matt F.</small>
            </div>
            <div className="quote">
              <p>
                &rdquo;Shopping with Zola was quick, no fuss, no bother. I am 84 years old and it was so easy to buy my granddaughter and her new husband a gift.&rdquo;
              </p>
              <small className="text-uppercase">Doris W.</small>
            </div>
          </div>
        </div>
      </div>
      <div className="press">
        <div className="row text-center seen-in">
          <small className="text-uppercase">As seen in</small><br /><br />
        </div>
        <div className="row">
          <div className="col-sm-4 col-xs-12 logo">
            <img src={modalImages('bridesBw')} className="center-block" width="150" alt="Brides" />
          </div>
          <div className="col-sm-4 col-xs-12 logo xl">
            <img src={modalImages('nytBw')} className="center-block" width="175" alt="The New York Times" />
          </div>
          <div className="col-sm-4 col-xs-12 logo">
            <img src={modalImages('vogueBw')} className="center-block" width="150" alt="Vogue" />
          </div>
          <div className="col-sm-4 col-xs-12 logo xl">
            <img src={modalImages('wsjBw')} className="center-block" width="175" alt="Wall Street Journal" />
          </div>
          <div className="col-sm-4 col-xs-12 logo">
            <img src={modalImages('fortuneBw')} className="center-block" width="125" alt="Martha Stewart Weddings" />
          </div>
          <div className="col-sm-4 col-xs-12 logo">
            <img src={modalImages('marthaStewartWeddingsBw')} className="center-block" width="125" alt="Martha Stewart Weddings" />
          </div>
        </div>
      </div>
      <div className="row text-center cta">
        <a role="button" className="btn btn-primary btn-wide" onClick={closeModal}>return to previous page</a>
      </div>
    </div>
  );
};


AboutZolaModal.propTypes = {
  closeModal: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(hideModal())
});

export default connect(
  null,
  mapDispatchToProps
)(AboutZolaModal);



// WEBPACK FOOTER //
// ./src/components/registry/AboutZolaModal.jsx